import { ProductTypeEnum } from "src/app/core/dtos/enum";

export const productTypeMappping = [
  { productTypeId: ProductTypeEnum.TestRegistration, productTypeName: "Test Registration" },
  { productTypeId: ProductTypeEnum.PhysicalProduct, productTypeName: "Physical Product" },
  { productTypeId: ProductTypeEnum.ElectronicProductEBook, productTypeName: "Electronic Product EBook" },
  { productTypeId: ProductTypeEnum.TransferService, productTypeName: "Transfer Service" },
  { productTypeId: ProductTypeEnum.ProductBundle, productTypeName: "Product Bundle" },
  { productTypeId: ProductTypeEnum.ShippingAndHandling, productTypeName: "Shipping And Handling" },
  { productTypeId: ProductTypeEnum.ElectronicProductOnline, productTypeName: "Electronic Product Online" },
  { productTypeId: ProductTypeEnum.OfficialScoreReport, productTypeName: "Official Score Report" },
  { productTypeId: ProductTypeEnum.ReEvaluationService, productTypeName: "ReEvaluation Service" },
  { productTypeId: ProductTypeEnum.ExpressScoreShippingService, productTypeName: "Express ScoreShipping Service" },
  { productTypeId: ProductTypeEnum.ExpressRatingService, productTypeName: "Express Rating Service" },
  { productTypeId: ProductTypeEnum.FeedbackService, productTypeName: "Feedback Service" },
  { productTypeId: ProductTypeEnum.ProductOption, productTypeName: "Product Option" },
  { productTypeId: ProductTypeEnum.OnlineProgram, productTypeName: "Online Program" },
  { productTypeId: ProductTypeEnum.ElectronicProductFile, productTypeName: "Electronic Product File" },
  { productTypeId: ProductTypeEnum.VoucherProduct, productTypeName: "VoucherProduct" },
  { productTypeId: ProductTypeEnum.HardcopyScoreReportShipping, productTypeName: "HardcopyScoreReportShipping" },
];
